import React from "react";
import noop from "lodash/noop";
import {ArrowLeft} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";
import styled from "styled-components";
import {PoweredByLogo} from "../../../../components/PoweredByLogo/PoweredByLogo";

type UnibuddyLogoHeaderProps = {
    onClick: () => void;
    onBack?: () => void;
    showBackButton?: boolean;
};

const Container = styled.a`
    background: white;
    display: flex;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
    margin-bottom: 15px;
    color: inherit;

    &:hover {
        color: inherit;
        text-decoration: none;
    }
`;

const LogoContainer = styled.div<{center?: boolean}>`
    padding: 10px;
    flex: 1;
    display: flex;
    ${({center}) => center && "justify-content: center;"}
`;

const BackContainer = styled.a`
    flex: 1;
    display: flex;
    text-align: center;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    flex-direction: row;
    color: inherit;

    &:hover {
        color: inherit;
    }
`;

const MaxContainer = styled.div`
    flex: 1;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 40px;
    color: #3b9dff;
    padding: 10px;

    & i {
        margin-left: auto;
    }
`;

const StyledArrowLeft = styled(ArrowLeft)`
    margin-right: 10px;
`;

export function UnibuddyLogoHeader({
    onClick,
    onBack = noop,
    showBackButton = false,
}: UnibuddyLogoHeaderProps) {
    const {t} = useTranslation("mentorCard");

    return (
        <Container onClick={onClick} id="diglett-header" data-test-id="diglett-header">
            {showBackButton ? (
                <BackContainer onClick={onBack} id="back-button" data-test-id="back-btn">
                    <StyledArrowLeft />
                    <span>{t("allBuddies", "All buddies")}</span>
                </BackContainer>
            ) : null}
            <LogoContainer center={showBackButton}>
                <PoweredByLogo />
            </LogoContainer>
            <MaxContainer>
                <i className="fa fa-arrows-alt" aria-hidden="true" />
            </MaxContainer>
        </Container>
    );
}
